import { KontaktDisplayModelFormGroup } from './../../../../api/models/ace/xFound/Portal/Core/CAQ/Models/kontakt-display-model';
import { AnredeDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anrede-display-model';
import { KontaktDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/kontakt-display-model';
import { TitelDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/titel-display-model';
import { StammdatenService } from '@/core/services/stammdaten.service';
import { StateService } from '@/core/services/state.service';
import { Component, Input, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ContactDataDisplayModelFormGroup, GlobalEnumsAceIdentischmit } from '@/api/model-index';
import { EnumValue } from '@/core/models/enumvalue.model';
import { I18nService } from '@/core/services/i18nService';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kontakt',
  templateUrl: './kontakt.component.html',
  styleUrls: ['./kontakt.component.scss']
})
export class KontaktComponent implements OnInit, OnDestroy {

  @Input("form")
  public kontaktForm: KontaktDisplayModelFormGroup;
  @Input("isRequired")
  public kontaktIsRequired: boolean = true;
  @Input("isAntragsteller")
  public kontaktIsAntragsteller: boolean = false;
  @Input("isWeitererAnsprechpartnerChecked")
  public isWeitererAnsprechpartnerChecked: boolean | null = null;

  protected languageSubscription: Subscription;

  protected abweichendeAdresseOptionenBase: Array<{ text: string, value: boolean }> = [
    { text: "Nein", value: false },
    { text: "Ja", value: true }
  ];

  public get abweichendeAdresseOptionen(){
    this.abweichendeAdresseOptionenBase.forEach(value => {
      if(value.value)
        value.text = this.translateService.instant('question.yes')
      else
        value.text = this.translateService.instant('question.no')
    })

    return this.abweichendeAdresseOptionenBase
  }

  public identischmitDefaultItem: EnumValue = new EnumValue( "_", 0, "_");

  public get identischmitOptionen(){
    let cbweitererAnsprechpartner: boolean = false;
    if (this.isWeitererAnsprechpartnerChecked == null) {
      let formGroup = <ContactDataDisplayModelFormGroup>this.kontaktForm.parent;
      if (formGroup && formGroup.CbweitererAnsprechpartner)
        cbweitererAnsprechpartner = formGroup.CbweitererAnsprechpartner.value == true;
    }
    else {
      cbweitererAnsprechpartner = this.isWeitererAnsprechpartnerChecked;
    }

    let list = GlobalEnumsAceIdentischmit.getAsDataset().slice();
    if(!cbweitererAnsprechpartner){
      let index = list.findIndex(x => x.Value == GlobalEnumsAceIdentischmit.WeitereAnsprechperson)
      if(index >= 0){
        list.splice(index, 1);
      }
    }
    list.forEach((item: EnumValue) => item.Description = this.translateService.instant("Enum.identischmit." + item.Name));

    return list;
  }

  @Input() kontakttyp: string;
  titelItems: TitelDisplayModel[];
  anredeItems: AnredeDisplayModel[];
  praefixTitelItems: TitelDisplayModel[];
  postfixTitelItems: TitelDisplayModel[];

  @Input()
  public set disabled(value: boolean){
    if(value)
      this.kontaktForm.disable()
  }

  public get getAbweichendeAdresse(): boolean {
    return this.kontaktForm.AbweichendeAdresse.value ?? false;
  }

  public get isAddressRequired(): boolean {
    return this.kontaktForm.AbweichendeAdresse.value ?? false;
  }

  public get kontakt(): KontaktDisplayModel {
    return this.kontaktForm?.value;
  }

  public get abweichendeAdresseFormControl(): UntypedFormControl {
    return this.kontaktForm.AbweichendeAdresse;
  }

  public get addresseFormGroup(): UntypedFormGroup {
    return this.kontaktForm.Address;
  }

  public get isIdentischMitFieldShown(): boolean{
    return this.kontakttyp == "vertretungsberechtigter" || this.kontakttyp == "weitererVertretungsberechtigter";
  }

  public get isIdentischMitFieldSet(): boolean{
    return  GlobalEnumsAceIdentischmit.getAsDataset().find(x => x.Value == this.kontaktForm.Identischmit.value) != null;
  }

  public get IsContactInformationRequired(): boolean{
    return this.kontaktIsRequired || this.kontaktForm.Firstname.value || this.kontaktForm.AnredeId.value || this.kontaktForm.Lastname.value || this.kontaktForm.AbweichendeAdresse.value == true
  }

  constructor(protected stateService: StateService, protected stammdatenService: StammdatenService,
    protected translateService: TranslateService, protected cdRef: ChangeDetectorRef, protected languageService: I18nService) {
  }

  ngAfterViewChecked(){
    let cbweitererAnsprechpartner: boolean = false;
    if (this.isWeitererAnsprechpartnerChecked == null) {
      let formGroup = <ContactDataDisplayModelFormGroup>this.kontaktForm.parent;
      if (formGroup && formGroup.CbweitererAnsprechpartner)
        cbweitererAnsprechpartner = formGroup.CbweitererAnsprechpartner.value == true;
    }
    else {
      cbweitererAnsprechpartner = this.isWeitererAnsprechpartnerChecked;
    }

    if (!cbweitererAnsprechpartner && this.kontaktForm.Identischmit.value == GlobalEnumsAceIdentischmit.WeitereAnsprechperson) {
      this.kontaktForm.Identischmit.patchValue(null);
      this.cdRef.detectChanges();
    }
  }

  ngOnInit(): void {
    this.loadAnreden();

    if (this.kontaktForm.Identischmit.value != 0)
      this.kontaktForm.Identischmit.setValue(this.kontakt.identischmit);
    else if(this.kontaktForm.Identischmit.value == 0)
      this.kontaktForm.Identischmit.setValue(null);

    if(this.stateService.IsEndvalidationEnabled && this.kontaktIsRequired)
    {
      this.kontaktForm.Firstname.addValidators(Validators.required);
      this.kontaktForm.AnredeId.addValidators(Validators.required);
      this.kontaktForm.Lastname.addValidators(Validators.required);
      this.kontaktForm.markAllAsTouched();
    }

    if (this.kontaktForm.AbweichendeAdresse.value == null || this.kontaktForm.AbweichendeAdresse.value == false)
      this.kontaktForm.AbweichendeAdresse.patchValue(false);

    this.stammdatenService.GetTitel().subscribe(titles => {
      this.praefixTitelItems = titles.filter(titelItem => !titelItem.isPostfixTitel);
      this.postfixTitelItems =  titles.filter(titelItem => titelItem.isPostfixTitel);
    });

    this.abweichendeAdresseFormControl.valueChanges.subscribe((value: boolean) => {
      if(value){
        this.addresseFormGroup.enable();
      }else {
        this.addresseFormGroup.disable();
      }
    })

    this.languageSubscription = this.languageService.languageChanged$.subscribe(() => {
      this.loadAnreden();
    });
  }

  protected loadAnreden(): void {
    this.stammdatenService.GetAnreden().subscribe(anreden => {
      this.anredeItems = anreden.filter(anrede => anrede.localeCode === this.languageService.language || anrede.localeCode === null);
      if (this.kontaktForm.AnredeId.value != null) {
        let anrede = anreden.find(x => x.anredeId == this.kontaktForm.AnredeId.value);
        if (anrede && !this.anredeItems.some(x => x.anredeId == anrede?.anredeId)) {
          this.anredeItems.push(anrede);
        }
      }
    });
  }

  public onAbweichendeAdresseValueChange(value: any): void {
    if (this.stateService.IsEndvalidationEnabled)
      this.kontaktForm.updateValueAndValidity();
  }

  public onIdentMitValueChanged(value:any){
    //override to valid value
    if(value == 0){
      this.kontaktForm.Identischmit.setValue(null);
    }
  }

  ngOnDestroy() {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }


  }
}
